import type { ReactNode } from 'react'
import styles from './DocumentManagementFilterViewer.module.css'

interface DocumentManagementFilterViewerProps {
  primaryControls: ReactNode
  filterControls: ReactNode
}

export function DocumentManagementFilterViewer({
  primaryControls,
  filterControls,
}: DocumentManagementFilterViewerProps) {
  return (
    <div className={styles.root}>
      {primaryControls}
      {filterControls}
    </div>
  )
}
